'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstComponent = function (_Component) {
  _inherits(VstComponent, _Component);

  function VstComponent() {
    _classCallCheck(this, VstComponent);

    var _this = _possibleConstructorReturn(this, (VstComponent.__proto__ || Object.getPrototypeOf(VstComponent)).call(this));

    _this._vstComponentUIUpdate = _this._vstComponentUIUpdate.bind(_this);
    _this.state = {};
    _this._oldComponentWillUnmount = _this.componentWillUnmount;
    _this.parentWillUnmount = _this.parentWillUnmount.bind(_this);
    _this.componentWillUnmount = function (e) {
      _this.parentWillUnmount(e);
      _this._oldComponentWillUnmount(e);
    };
    _this._oldComponentDidMount = _this.componentDidMount;
    _this.parentDidMount = _this.parentDidMount.bind(_this);
    _this.componentDidMount = function (e) {
      _this.parentDidMount(e);
      _this._oldComponentDidMount(e);
    };
    return _this;
  }

  _createClass(VstComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: '_returnTheme',
    value: function _returnTheme(index) {
      if (this.props.accent) {
        return _utils2.default.theme.getAccent(index);
      } else if (this.props.primary) {
        return _utils2.default.theme.getPrimary(index);
      }
      return _utils2.default.theme.getPrimary(index);
    }
  }, {
    key: '_theme',
    value: function _theme(index) {
      if (this.props.theme) {
        return _utils2.default.colors[this.props.theme][index];
      } else if (this.props.themeMap) {
        var keys = Object.keys(this.props.themeMap);
        var i = 0;
        for (i = 0; i < keys.length; i++) {
          var key = keys[i];
          if (this.props.primary && _utils2.default.theme.primaryKey === key || this.props.accent && _utils2.default.theme.accentKey === key) {
            return _utils2.default.colors[this.props.themeMap[key]][index];
          }
        }
      }
      return this._returnTheme(index);
    }
  }, {
    key: '_vstComponentUIUpdate',
    value: function _vstComponentUIUpdate() {
      this.forceUpdate();
    }
  }, {
    key: 'parentDidMount',
    value: function parentDidMount() {
      document.addEventListener('_vstui_change_theme', this._vstComponentUIUpdate);
    }
  }, {
    key: 'parentWillUnmount',
    value: function parentWillUnmount() {
      document.removeEventListener('_vstui_change_theme', this._vstComponentUIUpdate);
    }
  }]);

  return VstComponent;
}(_react.Component);

VstComponent.propTypes = {
  primary: _propTypes2.default.bool,
  accent: _propTypes2.default.bool,
  theme: _propTypes2.default.string,
  themeMap: _propTypes2.default.object
};

VstComponent.defaultProps = {
  primary: true,
  accent: undefined,
  theme: undefined,
  themeMap: undefined
};

module.exports = VstComponent;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstComponent.js
 **/